'use strict';


import {
	Box3,
	BoxGeometry, Euler,
	Group,
	Matrix4,
	Mesh,
	MeshStandardMaterial,
	Quaternion,
	Vector3,
} from 'three';
import { settingsData } from '../../../settings';
import { mergeGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils';

const selectedMaterial = new MeshStandardMaterial({color: '#f2ea00'});
const unselectedMaterial = new MeshStandardMaterial({color: '#beddfe'});


export class MiniMapBuilding {
	constructor (buildingScope,sceneScope) {
		this.building = buildingScope;
		this.group = new Group();
		this.scene = sceneScope;
		this.group.name = this.building.name;
		this.mesh = null;
		this.transform = null;
	}
	
	select() {
		this.mesh.material = selectedMaterial;
	}
	
	unselect() {
		this.mesh.material = unselectedMaterial;
	}
	
	create(useSelections) {
		if (useSelections) {
			const group = this.building.selectionsGroup;
			const position = new Vector3();
			this.building.selectionsGroup.getWorldPosition(position);
			const geometries = [];
			const floors = group.children.filter(floor => floor.name.startsWith('F'));
			const floorNumbers = floors.map(floor => Number(floor.name.split('_')[1]));
			floorNumbers.sort((a,b) => a - b);
			
			floorNumbers.forEach((floorNumber,index) => {
				const floorGroup = group.getObjectByName(`F_${floorNumber}`);
				
				floorGroup.children.forEach(apt => {
					if (!apt.name.startsWith('zero')) {
						const geometry = apt.geometry.clone();
						geometry.deleteAttribute( 'normal' );
						geometry.deleteAttribute( 'uv' );
						if (index !== floorNumbers.length - 1 ){
							geometry.scale(1,1.2,1);
						}
						geometry.applyMatrix4(apt.matrixWorld);
						geometries.push(geometry);
					}
				});
			});
			
			const geometry = mergeGeometries(geometries);
			geometry.computeVertexNormals();
			geometry.center();
			const size = new Vector3();
			geometry.boundingBox.getSize(size);
			geometry.translate(0,size.y / 2,0);
			
			this.mesh = new Mesh(geometry,unselectedMaterial);
			this.mesh.name = this.building.name;
			
			this.group.position.copy(position);
			this.group.position.y = 0;
			
			this.group.add(this.mesh);
			
		} else {
			const props = settingsData.allCrmData.filter(apt => apt.buildingEngineId === this.building.name);
			const bbox = new Box3();
			const size = new Vector3();
			const position = new Vector3();
			const quaternion = new Quaternion();
			this.building.selectionsGroup.getWorldPosition(position);
			this.group.position.copy(position);
			this.group.position.y = 0;
			
			const firstElement = this.building.selectionsGroup.getObjectByName(props[0].engineId);
			firstElement.getWorldQuaternion(quaternion);
			const euler = new Euler().setFromQuaternion(quaternion,'YXZ');
			this.group.rotation.y = euler.y;
			
			const selectionsClone = this.building.selectionsGroup.clone(true);
			selectionsClone.traverse(el => {
				el.rotation.set(el.rotation.x,0,el.rotation.z);
			});
			
			bbox.setFromObject(selectionsClone);
			bbox.getSize(size);
			
			const dimensions = new Vector3().subVectors( bbox.max, bbox.min );
			const boxGeo = new BoxGeometry(dimensions.x, dimensions.y, dimensions.z);
			const matrix = new Matrix4().setPosition(dimensions.addVectors(bbox.min, bbox.max).multiplyScalar( 0.5 ));
			boxGeo.applyMatrix4(matrix);
			boxGeo.center();
			boxGeo.translate(0,size.y / 2,0);
			
			this.mesh = new Mesh(boxGeo,unselectedMaterial);
			this.mesh.name = this.building.name;
			this.group.add(this.mesh);
			
			selectionsClone.traverse(el => {
				if (el.isMesh) {
					el.geometry.dispose();
					el.material.dispose();
				}
			});
		}
		
		if (this.transform) {
			if (!this.transform.position.equals(this.group.position)) {
				this.group.position.copy(this.transform.position);
			}
			
			if (!this.transform.rotation.equals(this.group.rotation)) {
				this.group.rotation.copy(this.transform.rotation);
			}
		}
		
		this.mesh.userData.type = 'Building';
	}
	
	set config(cfg) {
		this.transform = {
			position: new Vector3().fromArray(cfg.position),
			rotation: new Euler().fromArray(cfg.rotation)
		}
	}
	
}
